import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { AxisSummary } from './activityprogramme.models';
import { formatMoney, formatNumber, formatPercent } from './activityprogramme.normalizers';

type Props = { rows: AxisSummary[] };

const AxisSummaryPanel: React.FC<Props> = ({ rows }) => {
  const max = Math.max(...rows.map((r) => Math.abs(Number(r.revisedamount || 0))), 1);

  return (
    <Paper elevation={1} sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Axis Summary</Typography>
      <Stack spacing={1}>
        {rows.map((row) => {
          const width = Math.max(8, Math.min(100, Math.abs(Number(row.revisedamount || 0)) / max * 100));
          return (
            <Box key={row.axiscode}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ width: 90 }} variant="body2">{row.axiscode}</Typography>
                <Box sx={{ flex: 1, height: 22, borderRadius: 1, bgcolor: 'action.hover', overflow: 'hidden' }}>
                  <Box sx={{ width: `${width}%`, height: '100%', bgcolor: 'primary.light' }} />
                </Box>
                <Typography sx={{ width: 90 }} align="right" variant="body2">{formatNumber(row.activities)}</Typography>
                <Typography sx={{ width: 120 }} align="right" variant="body2">{formatMoney(row.revisedamount)}</Typography>
                <Typography sx={{ width: 80 }} align="right" variant="body2">{formatPercent(row.share)}</Typography>
              </Stack>
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
};

export default AxisSummaryPanel;
